import { Component, Input } from '@angular/core';
import { TRANSLATION_TAGS_NONE_SELECTED } from '@wdx/shared/utils';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'atom-input-none-selected',
    templateUrl: './atom-input-none-selected.component.html',
    standalone: false,
})
export class AtomInputNoneSelectedComponent {
    @Input() modalId: string;
    @Input() disabled: boolean;
    
    readonly TAGS_NONE_SELECTED = TRANSLATION_TAGS_NONE_SELECTED;
}
